import { ReactComponent as EmailIcon } from '@material-symbols/svg-400/rounded/alternate_email.svg?react'
import { ReactComponent as AttachFileIcon } from '@material-symbols/svg-400/rounded/attach_file.svg?react'
import { ReactComponent as BarcodeIcon } from '@material-symbols/svg-400/rounded/barcode.svg?react'
import { ReactComponent as MathIcon } from '@material-symbols/svg-400/rounded/calculate.svg?react'
import { ReactComponent as PhoneIcon } from '@material-symbols/svg-400/rounded/call.svg?react'
import { ReactComponent as BooleanIcon } from '@material-symbols/svg-400/rounded/check_box.svg?react'
import { ReactComponent as ArrayIcon } from '@material-symbols/svg-400/rounded/data_array.svg?react'
import { ReactComponent as IconIcon } from '@material-symbols/svg-400/rounded/emoji_symbols.svg?react'
import { ReactComponent as DateTimeIcon } from '@material-symbols/svg-400/rounded/event.svg?react'
import { ReactComponent as RichTextIcon } from '@material-symbols/svg-400/rounded/format_quote.svg?react'
import { ReactComponent as LookupIcon } from '@material-symbols/svg-400/rounded/frame_inspect.svg?react'
import { ReactComponent as FunctionIcon } from '@material-symbols/svg-400/rounded/function.svg?react'
import { ReactComponent as FormulaIcon } from '@material-symbols/svg-400/rounded/functions.svg?react'
import { ReactComponent as ImageArrayIcon } from '@material-symbols/svg-400/rounded/gallery_thumbnail.svg?react'
import { ReactComponent as ImageIcon } from '@material-symbols/svg-400/rounded/image.svg?react'
import { ReactComponent as JoinIcon } from '@material-symbols/svg-400/rounded/join_left.svg?react'
import { ReactComponent as KeyIcon } from '@material-symbols/svg-400/rounded/key.svg?react'
import { ReactComponent as LinkIcon } from '@material-symbols/svg-400/rounded/link.svg?react'
import { ReactComponent as ConnectionIcon } from '@material-symbols/svg-400/rounded/linked_services.svg?react'
import { ReactComponent as SingleCellIcon } from '@material-symbols/svg-400/rounded/move_selection_left.svg?react'
import { ReactComponent as CoordinateIcon } from '@material-symbols/svg-400/rounded/my_location.svg?react'
import { ReactComponent as NumberIcon } from '@material-symbols/svg-400/rounded/numbers.svg?react'
import { ReactComponent as ColorIcon } from '@material-symbols/svg-400/rounded/palette.svg?react'
import { ReactComponent as AddressIcon } from '@material-symbols/svg-400/rounded/personal_places.svg?react'
import { ReactComponent as QrCodeIcon } from '@material-symbols/svg-400/rounded/qr_code.svg?react'
import { ReactComponent as MultiSelectIcon } from '@material-symbols/svg-400/rounded/select_check_box.svg?react'
import { ReactComponent as RatingIcon } from '@material-symbols/svg-400/rounded/star_rate.svg?react'
import { ReactComponent as TextfieldIcon } from '@material-symbols/svg-400/rounded/table_convert.svg?react'
import { ReactComponent as TextFieldsAltIcon } from '@material-symbols/svg-400/rounded/text_fields_alt.svg?react'
import { ReactComponent as TextIcon } from '@material-symbols/svg-400/rounded/title.svg?react'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'

export const HeadersIconMap = {
  [ColumnTypes.Address]: AddressIcon,
  [ColumnTypes.AISEO]: TextFieldsAltIcon,
  [ColumnTypes.AITextProcessing]: TextFieldsAltIcon,
  [ColumnTypes.Array]: ArrayIcon,
  [ColumnTypes.Attachment]: AttachFileIcon,
  [ColumnTypes.Barcode]: BarcodeIcon,
  [ColumnTypes.Boolean]: BooleanIcon,
  [ColumnTypes.Color]: ColorIcon,
  [ColumnTypes.Connection]: ConnectionIcon,
  [ColumnTypes.Coordinate]: CoordinateIcon,
  [ColumnTypes.DateTime]: DateTimeIcon,
  [ColumnTypes.Email]: EmailIcon,
  [ColumnTypes.Formula]: FormulaIcon,
  [ColumnTypes.Function]: FunctionIcon,
  [ColumnTypes.Icon]: IconIcon,
  [ColumnTypes.Image]: ImageIcon,
  [ColumnTypes.ImageArray]: ImageArrayIcon,
  [ColumnTypes.Join]: JoinIcon,
  [ColumnTypes.Lookup]: LookupIcon,
  [ColumnTypes.Math]: MathIcon,
  [ColumnTypes.MultiSelect]: MultiSelectIcon,
  [ColumnTypes.Number]: NumberIcon,
  [ColumnTypes.Phone]: PhoneIcon,
  [ColumnTypes.QRCode]: QrCodeIcon,
  [ColumnTypes.Rating]: RatingIcon,
  [ColumnTypes.RichText]: RichTextIcon,
  [ColumnTypes.RowID]: KeyIcon,
  [ColumnTypes.SingleCell]: SingleCellIcon,
  [ColumnTypes.Slug]: LinkIcon,
  [ColumnTypes.Template]: TextfieldIcon,
  [ColumnTypes.Text]: TextIcon,
  [ColumnTypes.URL]: LinkIcon,
  [ColumnTypes.SessionID]: KeyIcon,
}
